import footerLogo from '../../assets/footerLogo.webp';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  return (
    <>
      <div className="w-full h-[14vh] bg-[#303030] text-white hidden md:flex justify-between px-4 py-[2vh]">
        <div className="flex justify-items-start justify-center justify-items-center">
          <Link to="">
            <img src={footerLogo} alt="Logo" className="px-32 inline h-[10vh]" />
          </Link>
          <div className="flex flex-col justify-center space-y-2">
            <span>StickyFeet Loyalty</span>
            <span>Worlds Largest Platform</span>
          </div>
        </div>
        <div className="flex flex-col justify-center space-y-2">
          <button className="font-extrabold">Call Now: +61 2 8007 6440</button>
          <Link to="/register">
            <button className="border-solid border-2 border-white rounded-xl px-2 py-1 text-sm">
              Get Sticky - Book Your Demo
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
